
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import FeatureGate from '../components/gate/FeatureGate';
// Lazy loading dos componentes
const HomePage = lazy(() => import('../pages/home/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Páginas legais
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));

import GlobalLayout from '../components/base/GlobalLayout';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/',
    element: <GlobalLayout />,
    children: [
      {
        path: 'dashboard',
        element: <DashboardPage />
      },
      {
        path: 'profile',
        element: <ProfilePage />
      },
      {
        path: 'privacidade',
        element: <PrivacyPage />
      },
      {
        path: 'termos',
        element: <TermsPage />
      },
      {
        path: 'cookies',
        element: <CookiesPage />
      }
    ]
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
